import React from "react";

const TrustBar = ({ items }) => (
  <div className="trust-bar">
    <div className="container">
      <div className="trust-items">
        {items.map((item, index) => (
          <div className="trust-item" key={index}>
            <div className="trust-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default TrustBar;
